import {useEffect, useState} from "react";
import { useSnackbar } from 'notistack';
import {useDeleteFacilityMutation} from "../../../services/authService";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import ConfirmDialog from "../../ConfirmDialog";
import messages from "../../../utils/messages";
import styles from "../showName/DeleteShowName.module.scss";

const DeleteFacility = ({ facility, setFacility, onDelete }) => {
    const [deleteFacility, { isSuccess, error, reset }] = useDeleteFacilityMutation();
    const { enqueueSnackbar } = useSnackbar();

    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    }

    const handleDelete = () => {
        deleteFacility(facility.id);
    }

    const handleMessages = () => {
        if(isSuccess){
            enqueueSnackbar(`${messages.success.deleteFacility}`, { variant: 'success' });
            reset();
            onDelete();
            setFacility(null);
        }
        if(error){
            enqueueSnackbar(`${messages.error.prefix} ${error?.data[0]?.errorMessage}`, { variant: 'error' });
        }
    }

    useEffect(() => {
        if(isSuccess || error){
            handleMessages();
        }
        // eslint-disable-next-line
    }, [isSuccess, error]);

    return (
        <>
            <DeleteOutlinedIcon
                fontSize="small"
                onClick={handleOpen}
                className={`${styles.icon} m-1`}
            />
            <ConfirmDialog
                title="Delete facility"
                open={open}
                setOpen={setOpen}
                onConfirm={handleDelete}
            >
                {messages.confirm.deleteFacility}
            </ConfirmDialog>
        </>
    )
}

export default DeleteFacility;